export const DISNEY_PROMO_ID = '21015';
export const VISION_FEATURE_CODE = '2641';
export const SPL_DISCOUNT_PROMO_IDS = ['18567', '18882'];
